<!--

This component is an admin level component which allows the addition, deletion,
and editing of backend modules. This serves as a convenience method for
developers, since you still need to integrate the component. The steps for
creating a new module are as follows:

1 Create a new component in this directory (ie. NewModule.vue)
2 Add the html component version via the form (ie. new-module)
3 The database will update itself, and you can add it to a user for editng

-->

<template>
<div class="row border m-2 mt-5">
<div class="col">

  <div class="row">
    
    <div class="col mt-3">
      <h2 class="mb-3 text-underline">Add A New Module</h2>
      <div class="row p-1">
        <div class="col-md-6 form-inline">
          <span class="">Module Name</span>
          <input type="text" v-model="name" class="form-control ml-3" />
          <button type="button" @click="createModule()" class="btn btn-primary ml-2">Create</button>
        </div>

        <div class="col-md-6 padding-1">
          
        </div>
      </div>
    </div>

    </div>

    <div class="row">
      <div class="col-12">
        <button type="button" @click="toggleModules()" class="btn btn-dark mt-3 mb-4">Manage Modules</button>

        <!-- show modules -->
        <div v-if="hidden == false">
          <module-button
            v-for="(row,index) in userModules"
            v-on:load-notes="loadNotes"
            v-on:unload-notes="unloadNotes"
            v-on:reload-modules="fetchModules"
            v-on:unload-modules="unloadModules"
            :id="row.id"
            :key="row.id"
            :name="row.name"
            :count="index">
          </module-button>
        </div>

      </div>
    </div>

  <!-- show notes based on selected module --> 
  <div v-for="id in notes">
    <load-notes :module-id="id"></load-notes>
  </div>

</div>
</div>
</template>

<script>
import axios from 'axios'
import ModuleButton from './ModuleButton.vue'
import LoadNotes from './LoadNotes.vue'

export default {
  components: {
    ModuleButton,
    LoadNotes
  },
  data () {
    return {
      name: "",
      hidden: true,
      gotModules: false,
      userModules: [],
      currentModuleId: 0,
      currentModuleName: "",
      moduleCount: 0,
      notes: []
    }
  },
  computed: {
    //incrementModuleCount: function() {
      //this.moduleCount = this.moduleCount + 1
    //}
  },
  methods: {
    loadNotes: function(id) {
      //add id of module to load notes for
      this.notes.push(id)
      
      //hide the rest of the modules while editing this one
      this.hideOtherModules(id)
    },
    unloadNotes: function() {
      this.notes = []
    },
    unloadModules: function() {
      this.userModules = []
      this.fetchModules()
    },
    toggleModules: function() {
      //only fetch users once per toggle
      if (this.gotModules == false) {
        this.fetchModules()
      }

      if (this.hidden == true) {
        this.hidden = false
      } else {
        this.hidden = true
        this.unloadNotes()
      }
    },

    createModule: function() {
      //set local
      let local = this

      //create json request object
      let req = {}
      req.name = this.name

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/add',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.name = undefined
          local.fetchModules()
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },

    fetchModules: function() {
      //set local
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/all',
          data: "",
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.gotModules = true
          local.setUserModules(response.data)
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },

    setUserModules: function(data) {
      this.userModules = data
    },

    hideOtherModules: function(id) {
      //hide all modules excpet this one
      let newModules = []

      for (var i=0; i<this.userModules.length; i++) {
        
        if (this.userModules[i].id == id) {
          newModules.push(this.userModules[i])
        }
      }

      this.userModules = newModules
    }
  }
}
</script>

<style>
</style>
